import { NpsFrequency } from '../types/nps';

export const NPS_INTRO_TEXT =
  'NPS (Net Promoter Score) is a key customer service metric that helps us'
  + ' understand our performance and identify areas for improvement.'
  + ' By sharing your thoughts, you\'re helping us create a better'
  + ' experience for you and others. This short survey will only take'
  + ' a minute and your feedback makes a big difference!';

export const NPS_SCORE_QUESTION =
  'How likely are you to recommend Morrisons Daily as a business partner?';

export const NPS_FEEDBACK_LABEL =
  'To help us understand better, please tell us more'
  + ' about why you have given us that score? (Optional)';

export const NPS_FEEDBACK_PLACEHOLDER = 'Please provide additional feedback...';

export const NPS_SUBMIT_BUTTON = 'Submit';

export const NPS_MODAL_HEADER = 'NPS Feedback';

export const NPS_DWELL_TIME_MS = 120000; // 2 minutes

export const NPS_FREQUENCY_DAYS: Partial<Record<NpsFrequency, number>> = {
  Weekly: 7,
  Monthly: 30,
};
